import { icons } from 'src/assets/iconDef/icon.def';
export const opticalMenuDef = [
    {
        name: 'menu.op_order',
        icon: 'fa fa-building-o',
        children: [{
            name: 'menu.optical_Walkin',
            resource: 'opOpticalLayout',
            icon: 'icons.application.user',
            url: 'opOpticalLayout',
            auto_crud: true,
            breadcrumb: 'Op Card',
            check_permission: false
        },
        {
            name: 'menu.optical_Walkin',
            resource: 'opticalOrder',
            icon: 'icons.application.user',
            url: 'opOpticalOrders',
            auto_crud: true,
            showMenu:false,
            check_permission: false
        },
        {
            name: "menu.optical_advance",
            resource: "opticalAdvanceLayout",
            icon: "fa fa-user",
            url: "opticalAdvanceLayout",
            auto_crud: true,
            check_permission: false
        },
        {
            name: "menu.optical_advance",
            resource: "deposit_optical_admissionId",
            icon: "fa fa-user",
            url: "deposit_optical_admissionId",
            auto_crud: true,
            check_permission: false
        },
        {
            name: "menu.optical_advance",
            resource: "approve_deposit_optical_admissionId",
            icon: "fa fa-user",
            url: "approve_deposit_optical_admissionId",
            auto_crud: true,
            check_permission: false
        },
        {
            name: "menu.optical_deposit",
            "resource": "optical_deposit",
            url: "optical_deposit",
            auto_crud: true,
            check_permission: false
        },
        {
            name: "menu.gst_details_sale_to_company",
            "resource": "gst_details_sale_to_company",
            url: "gst_details_sale_to_company",
            auto_crud: true,
            check_permission: false
        },
        {
            name: "menu.gst_details_sscm_grnMaster_opticalale_to_company",
            "resource": "scm_grnMaster_optical",
            url: "scm_grnMaster_optical",
            auto_crud: true,
            check_permission: false
        }
        ]
    }
]